/* @ngInject */
export default function HISWizardFactory($uibModal, $http, HPConfig, $q) {
    let modalInstance = null;

    return {
        openHISWizardModal(mandatory) {
            if (!!modalInstance) {
                return;
            }

            modalInstance = $uibModal.open({
                templateUrl: 'app/hisWizard/hisWizard.html',
                controller: 'HISWizardController',
                controllerAs: 'hisWizard',
                size: 'full-screen',
                animation: false,
                keyboard: !mandatory,
            });

            modalInstance.closed.then(() => {
                modalInstance = null;
            });

            console.log(modalInstance);
        },
        validateHISNumber(licenseNumber) {
            return $http
                .get(`${HPConfig.heroProApi}ContractorUser/ValidateHISLicense?licenseNumber=${licenseNumber}`)
                .then(response => {
                    return response.data;
                });
        },
        getHISTrainingRedirectURI() {
            return $http
                .get(`${HPConfig.heroProApi}ContractorUser/GetHISTrainingRedirectURI`)
                .then(response => {
                    return response.data;
                });
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/hisWizard/hisWizardFactory.js